import { ListItemButton } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

type Props = {
  item: any;
};

const SlidebarItemWithOutCollapse = ({ item }: Props) => {
  const location = useLocation();
  const [isActive, setActive] = useState(false);

  useEffect(() => {
    setActive(location.pathname.startsWith(item?.path));
  }, [location.pathname, item?.path]);

  return (
    item.sidebarProps &&
    item.path && (
      <ListItemButton
        component={Link}
        to={item.path}
        className="w-full flex p-[10px] items-center gap-2.5"
        sx={{
          "&:hover": {
            backgroundColor: "#005CA6",
            color: "#ffffff",
          },
          backgroundColor: isActive ? "#005CA6" : "unset",
          color: isActive ? "#ffffff" : "#000000",
          padding: "10px",
          borderRight: "unset",
        }}
      >
        <span className="material-symbols-outlined text-inherit text-[25px] font-extralight">
          {item.sidebarProps.icon}
        </span>

        <span className="text-inherit text-[13px] font-medium tracking-wide whitespace-normal">
          {item.sidebarProps.displayText}
        </span>
      </ListItemButton>
    )
  );
};

export default SlidebarItemWithOutCollapse;